import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles/createTheme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderBottom: 'solid #ccc 1px',
      margin: theme.spacing(1, 0, 1, 0),
      '& .title': {
        lineHeight: '17pt',
      },
      '&.total': {
        borderBottom: 'none',
        '& .title': { lineHeight: '28pt' },
      },
      '& .minLabel, & .maxLabel': {
        height: theme.spacing(4),
      },
      '& .minLabel': {
        paddingRight: theme.spacing(2),
      },
      '& .maxLabel': {
        paddingLeft: theme.spacing(2),
      },
      '& .text': {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1)
      }
    },
  }),
);

export default useStyles;
